import templateUrl from 'servicestack/email/send-email-prompt.htm'
import controller from 'servicestack/email/send-email-prompt.controller'
import config from 'servicestack/email/send-email-config'
import modals from 'webmodals/modals'

export default (options) => modals.open(Object.assign({
    size: options.size || 'md',
    backdrop: 'static',
    templateUrl: options.templateUrl || templateUrl,
    controller,
    bindToController: true,
    controllerAs: '$ctrl',
    resolve: {
        options: () => Object.assign({}, config, options)
    }
}, options.modal)).result;